import { httpGetAndParse, httpPost, httpPut } from '../utils/fetchService';

export const insertInformationalData = ({ taxYear, period, businessEntityId, jurisdictionId }) =>
  httpPost({
    route: '/api/shared/state-specific-information',
    errorMessage: 'Inserting informational data failed',
    body: { taxYear, period, orgId: businessEntityId, jurisdictionId },
  });

export const fetchFormList = ({
  taxYear,
  period,
  filingTypeId,
  businessEntityId,
  jurisdictionId,
}) =>
  httpGetAndParse({
    route: `/api/shared/forms/${taxYear}/${period}/${filingTypeId}/${businessEntityId}/${jurisdictionId}`,
    errorMessage: 'Fetching state specific information form list failed',
  });

export const fetchFormFields = ({ taxYear, period, businessEntityId, jurisdictionId, swpFormId }) =>
  httpGetAndParse({
    route: `/api/shared/state-specific-information/${taxYear}/${period}/${businessEntityId}/${jurisdictionId}/${swpFormId}`,
    errorMessage: 'Fetching state specific information form fields failed',
  });

export const updateFormFields = ({ rows }) =>
  httpPut({
    route: '/api/shared/state-specific-information',
    errorMessage: 'Updating state specific information form fields failed',
    body: { rows },
  });
